<nav class="breadcrumb-nav" aria-label="Breadcrumb">
  <img class="breadcrumb-icon" alt="" src="assets/icons/nav/breadcrumb.svg" />
  <ol class="breadcrumb-list">
    @for (crumb of breadcrumbs; track $index; let last = $last) {
      <li class="breadcrumb-entry">
        @if (last) {
          <span aria-current="page">{{ crumb.label }}</span>
        } @else if (crumb.url) {
          <a [routerLink]="crumb.url">{{ crumb.label }}</a>
        } @else if (crumb.isSidebarTrigger) {
          <a
            role="button"
            tabindex="0"
            (keydown.enter)="onBreadcrumbClick(crumb)"
            (keydown.space)="$event.preventDefault(); onBreadcrumbClick(crumb)"
            (click)="onBreadcrumbClick(crumb)"
          >
            {{ crumb.label }}
          </a>
        } @else {
          <span>{{ crumb.label }}</span>
        }
      </li>
    }
  </ol>
</nav>
